var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import LazyLoad from 'react-lazyload';
//import { ReactComponent as Placeholder} from '../images/placeholder.svg';
import classNames from 'classnames';
import AOS from "aos";
import SeparatorIcon from "./svg/SeparatorIcon";
var Teaser = function (props) {
    var _a = useState([]), primaryCategoryClass = _a[0], setPrimaryCategoryClass = _a[1];
    var _b = useState([]), categoriesIn = _b[0], setCategoriesIn = _b[1];
    var _c = props.teaser, storyTitle = _c.storyTitle, storyTeaser = _c.storyTeaser, storyAuthor = _c.storyAuthor, storyThumbnail = _c.storyThumbnail, storyLink = _c.storyLink, categories = _c.categories, primaryCategory = _c.primaryCategory;
    useEffect(function () {
        AOS.init();
        AOS.refresh();
        if (categories && primaryCategory) {
            var categoryWithWeight = categories
                .filter(function (cat) {
                return cat.term_id === primaryCategory;
            })
                .map(function (catObj) {
                return catObj.slug;
            });
            setPrimaryCategoryClass(categoryWithWeight[0]);
        }
        else {
            console.log(categories);
            //setPrimaryCategoryClass(categories[0].slug)
        }
    }, []);
    return _jsx(_Fragment, { children: props.teaser && _jsx("div", __assign({ "data-aos": "fade-up", className: 'stories rounded-teaser overflow-hidden' }, { children: _jsxs("a", __assign({ href: storyLink }, { children: [_jsx("div", __assign({ className: 'relative pb-60 overflow-hidden' }, { children: _jsx(LazyLoad, __assign({ height: 200, offset: 100 }, { children: storyThumbnail ?
                                _jsx("img", { src: storyThumbnail, className: 'absolute inset-0 h-full w-full object-cover' }, void 0) :
                                _jsx("img", { src: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5NTAgNjAwIiBjbGFzcz0iaW1nLWZsdWlkIHJvdW5kZWQgbXgtYXV0byBkLWJsb2NrIiB3aWR0aD0iOTUwIiBoZWlnaHQ9IjYwMCI+CiAgICAgICAgICAgICAgICAgICAgPHJlY3Qgd2lkdGg9Ijk1MCIgaGVpZ2h0PSI2MDAiIGZpbGw9IiNjY2NjY2MiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICA8dGV4dCB4PSI1MCUiIHk9IjUwJSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9Im1vbm9zcGFjZSIgZm9udC1zaXplPSIyNnB4IiBmaWxsPSIjMzMzMzMzIj4gPC90ZXh0PiAgIAogICAgICAgICAgICAgICAgPC9zdmc+CiAgICAgICAgICAgICAgICA8IS0tPGEgZG93bmxvYWQ9IkZJTEVOQU1FLnBuZyIgaHJlZj0iZGF0YTppbWFnZS9wbmc7YmFzZTY0LGFzZGFzZC4uLiI+RG93bmxvYWQ8L2E+LS0+', className: 'absolute inset-0 h-full w-full object-cover' }, void 0) }), void 0) }), void 0), _jsxs("div", __assign({ className: classNames('stories__header pr-5 pl-5 pt-5 pb-0 md:pt-5 md:pr-5 md:pl-5 pb-0 w-full') }, { children: [_jsx(SeparatorIcon, { className: classNames('stories__icon', primaryCategoryClass) }, void 0), _jsx("h3", __assign({ className: classNames('title 3xl', primaryCategoryClass) }, { children: storyTitle }), void 0), _jsx("div", __assign({ className: 'stories__author mt-2' }, { children: storyAuthor.author_name }), void 0)] }), void 0), _jsx("div", __assign({ className: 'stories__teaser-text p-5' }, { children: storyTeaser }), void 0)] }), void 0) }), void 0) }, void 0);
};
export default Teaser;
